import React, { useState, useEffect } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import { useParams } from "react-router-dom";
import { TextField, Button, Grid, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const UpdatePitched = () => {
  const { pitchId } = useParams();
  // console.log(pitchId + "----");
  const [pitchedData, setPitchedData] = useState({
    leadname: "",
    contactno: "",
    leademail: "",
    leadlocation: "",
    leadsource: "",
    leadcomments: "",
    changestatus: "",
    status: "active",
  });

  const [submitMessage, setSubmitMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const fetchPitchedData = async () => {
      try {
        const response = await axiosInstance.get(`/api/getPitched/${pitchId}`);
        // console.log(response.data);
        if (response && response.data) {
          setPitchedData(response.data);
        } else {
          // Handle error or set default values
        }
      } catch (error) {
        // Handle network errors
      }
    };

    fetchPitchedData();
  }, [pitchId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPitchedData({ ...pitchedData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(pitchedData);
    try {
      const response = await axiosInstance.put(
        `/api/updatePitched/${pitchId}`,
        pitchedData
      );

      if (response.status === 200) {
        setSubmitMessage("Pitched data updated successfully!");
        setOpenSnackbar(true);

        setTimeout(() => {
          setOpenSnackbar(false);
          setSubmitMessage("");
        }, 3000);

        setEditMode(false);
      } else {
        // Handle error
      }
    } catch (error) {
      // Handle network errors
    }
  };

  const handleEditClick = () => {
    setEditMode(true);
  };

  return (
    <>
      <Grid
        item
        container
        xs={12}
      >
        <Grid
          item
          container
          xs={6}
        >
          <Typography variant="h5">Update Pitched Details</Typography>
        </Grid>
        <Grid
          item
          container
          xs={6}
          style={{ justifyContent: "end" }}
        >
          <EditIcon
            onClick={handleEditClick}
            style={{ cursor: "pointer" }}
          />
        </Grid>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Pitched Name"
            name="leadname"
            value={pitchedData.leadname}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={!editMode}
          />
          <TextField
            label="Contact Number"
            name="contactno"
            value={pitchedData.contactno}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={!editMode}
          />
          <TextField
            label="Pitched Email"
            name="leademail"
            value={pitchedData.leademail}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={!editMode}
          />
          <TextField
            label="Pitched Location"
            name="leadlocation"
            value={pitchedData.leadlocation}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={!editMode}
          />
          <TextField
            label="Pitched Source"
            name="leadsource"
            value={pitchedData.leadsource}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={!editMode}
          />
          <TextField
            label="Pitched Comments"
            name="leadcomments"
            value={pitchedData.leadcomments}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            multiline
            rows={4}
            disabled={!editMode}
          />
          <TextField
            label="Change Status"
            name="changestatus"
            value={pitchedData.changestatus}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={!editMode}
          />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={!editMode}
          >
            Save
          </Button>
        </form>
      </Grid>
    </>
  );
};

export default UpdatePitched;
